<template>
  <div class="my-0">
     <v-menu
      v-model="menu1"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="225px"
      close-delay
      :disabled="disabled"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            :color="!disabled ? bgColor : 'indigo lighten-4'"
            class="elevation-0 white--text"
          >
            <v-icon v-if="filterIcon" class="mr-2">{{filterIcon}}</v-icon>
            {{dateStart}} ~ {{dateEnd}}
          </v-btn>
        </template>
        <v-card>
          <div class="d-flex">
            <v-list dense>
              <v-list-item-group color="primary" v-model="model">
                <v-list-item v-for="(item, index) in getRanges" 
                  :key="index" 
                  link
                  @click="getRange(item.range, index)"
                >
                  <v-list-item-action>
                    <v-list-item-title>{{ item.label }}</v-list-item-title>
                  </v-list-item-action>
                </v-list-item>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  nudge-top="325"
                  nudge-left="225"
                  transition="scale-transition"
                  offset-x
                  min-width="290px"
                >
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item link v-bind="attrs" v-on="on">
                    <v-list-item-action>
                      <v-list-item-title>Custom</v-list-item-title>
                    </v-list-item-action>
                  </v-list-item>
                </template>
                <v-card>
                  <v-date-picker           
                    show-current="false"
                    v-model="pickerDateStart" 
                    :allowed-dates="allowedDateEnd"            
                  >
                  </v-date-picker>
                  <v-date-picker           
                    show-current="false"
                    v-model="pickerDateEnd" 
                    :allowed-dates="allowedDateEnd"            
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="click"
                      class="ml-auto"
                    >
                      Apply
                    </v-btn>
                  </v-date-picker>
                </v-card>
              </v-menu>
            </v-list-item-group>
          </v-list>
          <!-- <RangeDatePicker 
            v-model="dates"
            language="en"
            class="range-date-picker"
            colorActive="#90CAF9"
            colorToday="#263238"
            colorSelected="#1976D2"
          />
          <v-btn
            text
            color="primary"
            @click="click"
            class="ml-auto"
          >
            Apply
          </v-btn> -->
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
//import RangeDatePicker from 'vue-easy-range-date-picker'

export default {
    props: {
      start: {
        type: String
      },
      end: {
        type: String
      },
      excludePeriod: {
        type: Array
      },
      defaultPeriod: {
        type: Number
      },
      bgColor: {
        type: String,
        default: 'indigo'
      },
      filterIcon: {
        type: String
      },
      setDates: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    components: {
        //RangeDatePicker
    },
    data() {
    return {
      menu1: false,
      menu2: false,
      model: (sessionStorage.getItem('defaultPeriod') && this.setDates) ? +sessionStorage.getItem('defaultPeriod') : this.defaultPeriod,
      dates: {start: this.start, end: this.end},
      pickerDateStart: new Date().toISOString().substr(0, 10),
      pickerDateEnd: new Date().toISOString().substr(0, 10),
      dateStart: this.start,
      dateEnd: this.end,
      ranges: [
        {
          label: 'Today',
          range: [
            new Date(new Date().setDate(new Date().getDate())).toISOString().substr(0, 10),
            new Date(new Date().setDate(new Date().getDate())).toISOString().substr(0, 10),
          ]
        },
        {
          label: 'Yesterday',
          range: [
            new Date(new Date().setDate(new Date().getDate()-1)).toISOString().substr(0, 10),
            new Date(new Date().setDate(new Date().getDate()-1)).toISOString().substr(0, 10),
          ]
        },
        {
          label: 'Last 7 Days',
          range: [
            new Date(new Date().setDate(new Date().getDate()-6)).toISOString().substr(0, 10),
            new Date().toISOString().substr(0, 10),
          ]
        },
        {
          label: 'Last 30 Days',
          range: [
            new Date(new Date().setDate(new Date().getDate()-29)).toISOString().substr(0, 10),
            new Date().toISOString().substr(0, 10),
          ]
        },
        {
          label: 'This Month',
          range: [
            new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
            new Date().toISOString().substr(0, 10),
          ]
        },
        {
          label: 'Last Month',
          range: [
            new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth()-1, 1)).toISOString().substr(0, 10),
            new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 0)).toISOString().substr(0, 10),
          ]
        },
        {
          label: 'Last 90 Days',
          range: [
            new Date(new Date().setDate(new Date().getDate()-89)).toISOString().substr(0, 10),
            new Date().toISOString().substr(0, 10),
          ]
        },
        {
          label: 'This Year',
          range: [
            new Date(Date.UTC(new Date().getFullYear(), 0, 1)).toISOString().substr(0, 10),
            new Date().toISOString().substr(0, 10),
          ]
        },
        {
          label: 'Last Year',
          range: [
            new Date(Date.UTC(new Date().getFullYear()-1, 0, 1)).toISOString().substr(0, 10),
            new Date(Date.UTC(new Date().getFullYear()-1, 11, 31)).toISOString().substr(0, 10),
          ]
        },
      ],
      // calendarData: {},
      // calendarConfigs: {
      //     sundayStart: false,
      //     dateFormat: 'dd/mm/yyyy',
      //     isDatePicker: false,
      //     isDateRange: true,
      //     isSeparately: true,
      //     isMultiple: true,
      //     calendarsCount: 2,
      //     isLayoutExpandable: true
      // }
      
    }
  },
  mounted() {

  },
  methods: {
      handleChange(values) {
        this.dateStart = values[0].toISOString().substr(0,10)
        this.dateEnd = values[1].toISOString().substr(0,10) 
        this.$emit('getDates', { dateStart: this.dateStart, dateEnd: this.dateEnd})
      },
      allowedDateEnd(val) {
          return  new Date(val).toISOString().substr(0, 10) <= new Date().toISOString().substr(0, 10)
      },
      allowedDateStart(val) {
          return  new Date(val).toISOString().substr(0, 10) <= new Date().toISOString().substr(0, 10)
      },
      getRange(range, index) {
        this.dateStart = range[0]
        this.dateEnd = range[1]
        if (this.setDates) {
          sessionStorage.setItem('dateStart', this.dateStart)
          sessionStorage.setItem('dateEnd', this.dateEnd)
          sessionStorage.setItem('defaultPeriod', index)
        }
        this.$emit('getDates', { dateStart: this.dateStart, dateEnd: this.dateEnd, compareMode: false })
        this.menu1 = false
      },
      click() {
        this.dateStart = this.pickerDateStart
        this.model = 9
        this.dateEnd = (this.pickerDateEnd) ? this.pickerDateEnd : this.pickerDateStart
        if (this.pickerDateStart > this.pickerDateEnd) {
          this.dateStart = this.pickerDateEnd
          this.dateEnd = this.pickerDateStart
        }

        if (this.setDates){
          sessionStorage.setItem('dateStart', this.dateStart)
          sessionStorage.setItem('dateEnd', this.dateEnd)
          sessionStorage.setItem('defaultPeriod', this.model)
        }

        this.$emit('getDates', { dateStart: this.dateStart, dateEnd: this.dateEnd, compareMode: false })
          this.menu1 = false
          this.menu2 = false
      }
  },
  watch: {
    start: function () {
      this.dateStart = this.start
      this.dateEnd = this.end
    },
    end: function () {
      this.dateStart = this.start
      this.dateEnd = this.end
    },
  },
  computed: {
    getRanges(){
        const arr = this.ranges.filter((item , index)=> {
          return !this.excludePeriod.includes( index )
        })
      return arr;
    }
  }
};
</script>

<style>
.range-date-picker-container {
  cursor: pointer;
  font-size: 14px;
  position: relative;
}
.range-date-picker-container .range-date-picker {
    position: absolute;
    top: 50px;
    left: 0px;
  }
.range-date-picker-container .range-date-input {
    padding: 10px;
    width: 300px;
  }
.panelIn-enter {
  transform: translateY(-10px);
}
.panelIn-enter-active {
  transition: transform 0.3s ease;
}
.panelIn-enter-to {
  transform: translateY(0);
}
</style>